import React, { useEffect } from "react";
import {useSelector, useDispatch} from "react-redux";

import styles from "./Group.module.scss";
import {fetchExtraFacets, fetchFacets, getMiddlefacetGroups} from "../../Store/Actions/NewFilterActions";
import {ACTIVATE_GROUP, CLEAR_ACTIVE_GROUP} from "../../Store/Actions/ActionTypes";
import getActiveMainFacetID from "../../Utils/getActiveMainFacetID";
// Grupper med data i filter 
const Group = (props) => {
    const {id, value, facetName, middlefacetGroupID, middlefacetID, weight, defaultActive, childrenTotalCount} = props;
    const dispatch = useDispatch();
    const newFilterState = useSelector(state => state.newFilterReducer);
    const activeGroup = newFilterState.activeGroup;
    const activeFilters = {...newFilterState.activeFilters};
    const activeMainFacetID = getActiveMainFacetID(newFilterState);
    const facets = {...newFilterState.facets};
    const responseCache = newFilterState.responseCache;
    const isActive = (id === activeGroup);
    
    // Sets group active if its only one group available
    useEffect(() => {
        if (defaultActive && !isActive) {
            dispatch({type: ACTIVATE_GROUP, payload: {id: id}});
        } 
    },[])

    let myClass = `${styles.wrapper}`;
    if (isActive) {
        myClass += ` ${styles.active}`;
    }

    let myStyle = weight ? {order: weight} : null;

    const handleClick = () => {
        if (!isActive) {
            dispatch({type: ACTIVATE_GROUP, payload: {id: id}});

            if (facets[activeMainFacetID] !== undefined) {
                if (middlefacetID == null) { // Null parent means that this is a main group (it does not come from a subfacet)
                    if (facets[activeMainFacetID].children[id].children === undefined) {
                        dispatch(fetchFacets(responseCache, facetName, id, activeFilters));
                    }
                }
                else {
                    const groups = getMiddlefacetGroups(middlefacetGroupID, activeFilters[middlefacetGroupID].value);

                    const activeMainFacet = facets[activeMainFacetID];
                    const middlefacetGroup = activeMainFacet.middlefacets[middlefacetGroupID];
                    const middlefacet = middlefacetGroup.children[middlefacetID];
                    const middlefacetGroupValue = groups[id].value;
                    if (middlefacet.children === undefined || middlefacet.children[id] === undefined) {
                        dispatch(fetchExtraFacets(responseCache, facetName, id, activeFilters, middlefacetGroupID, middlefacetID, middlefacetGroupValue));
                    }
                }
            }
        }
        else {
            dispatch({type: CLEAR_ACTIVE_GROUP});
        }

    };

    const handleKeyDown = (e) => {
        if (e.keyCode === 13) { // Handle enter
            e.target.click();
        }
    };

    return (
        <div tabIndex="0" style={myStyle} className={myClass} onClick={handleClick} onKeyDown={handleKeyDown} data-children-total-count={childrenTotalCount}>{value}</div>
    )
};

export default Group;